import React from 'react';
import styles from './index.module.scss'

interface ConfirmDialogProps {
  visible: boolean;
  content?: string;
  title?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  textConfirm?: string;
  textCancel?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  visible,
  content,
  title,
  onCancel,
  onConfirm,
  textConfirm,
  textCancel
}) => {
  if (!visible) return null;

  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();       // 执行业务逻辑
      onCancel?.();
    } else {
      onCancel?.();             // 如果没传 onConfirm，就直接关闭弹窗
    }
  };

  return (
    <div className={styles.mask} onClick={onCancel} >
      <div 
        className={styles.box}
        onClick={(e) => e.stopPropagation()} // 阻止事件冒泡  
      >
        <div className={styles.title}>{title}</div>

        <div className={styles.content}>{content}</div>

        <div className={styles.actions}>
          <button onClick={onCancel}>{textCancel}</button>
          <button onClick={handleConfirm}>{textConfirm}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
